<div class="search-suggest-recent-terms">
  <div class="d-flex justify-content-start headline">{{ 'suggest.recent_searched_terms.headline' | translate }}</div>
  <ul>
    @for (term of searchTerms$ | async; track term) {
    <li>
      <button type="button" [innerHTML]="term | ishHighlight : (inputTerms$() | async)" (click)="submit(term)"></button>
    </li>
    }
  </ul>
</div>
